var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusMorePics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.532104,
    y: 0.703125,
    width: 28.4248,
    height: 28.4248,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_9269_23898",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_9269_23898",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAABTklEQVR4nO3bMQ6CUBAA0T0IN5i7eFEPqSGhslAK45/IvGQ7CtjRApI/kyRJkiQ5Y5uZ+4fZr8mPMDOPD7Nfk4JcE/1DXCiICwVxoSAuFMSFgrhQEBcK4kJBXCiICwVxoSAuFMSFgrhQEBcK4kJBXCiICwVxoSAuFMSFgrhQEBcK4kJBXCiICwVxoSAuFMSFgrhQEBcK4kJBXLhykO14ONPcTgS5Ce7zdb5yEPV+4uGbObWDfZcFGc8PpiCzPkJBZv3iCzLrl12QWb/ggsz6pRZk1i9SFaQXw3G9GBpx5U8nRhTEhYK4UBAXCuJCQVwoiAsFcaEgLhTEhYK4UBAXCuJCQVwoiAsFcaEgLhTEhYK4UBAXCuJCQVwoiAsFcaEgLhTEhYK4UBAXCuJCQVwoiAsFcaEgLhTEhYK4UBCX7TjR+m7+9oBlkiRJkswXPQE/EyNEACIdJwAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusMorePics);
export default __webpack_public_path__ + "static/media/Plus-more-pics.730fbc86e0e523a14a6eb04087218bf9.svg";
export { ForwardRef as ReactComponent };